import {Action, createReducer, on} from '@ngrx/store';
import {
  MailerServiceProvidersList,
  MailerServiceProvidersListSuccess,
  MailerServiceProvidersListError,
  MailerServiceProviderDelete,
  MailerServiceProviderDeleteSuccess,
  MailerServiceProviderDeleteError,
  MailerServiceProviderCreate,
  MailerServiceProviderCreateSuccess,
  MailerServiceProviderCreateError,
  MailerServiceProviderUpdate,
  MailerServiceProviderUpdateSuccess,
  MailerServiceProviderUpdateError,
  MailerServiceProviderSetDefault,
  MailerServiceProviderSetDefaultSuccess,
  MailerServiceProviderSetDefaultError,
  ResetMailerServiceProviderState,
} from '@app/stores/mailer-service-provider/mailer-service-provider.actions';
import {initialMailerServiceProviderState} from '@app/stores/mailer-service-provider/mailer-service-provider.state';

const generateReducer = createReducer(initialMailerServiceProviderState,
  on(MailerServiceProvidersList, (state) => ({
    ...state,
    paginatedMailerServiceProviders: null,
    success: '',
    error: ''
  })),
  on(MailerServiceProvidersListSuccess, (state, {paginatedMailerServiceProviders}) => ({
    ...state,
    paginatedMailerServiceProviders,
    success: '',
    error: ''
  })),
  on(MailerServiceProvidersListError, (state, {error}) => ({
    ...state,
    paginatedMailerServiceProviders: null,
    success: '',
    error
  })),
  on(MailerServiceProviderDelete, (state) => ({
    ...state,
    success: '',
    error: ''
  })),
  on(MailerServiceProviderDeleteSuccess, (state) => ({
    ...state,
    success: 'Provider deleted successfully',
    error: ''
  })),
  on(MailerServiceProviderDeleteError, (state, {error}) => ({
    ...state,
    success: '',
    error
  })),
  on(MailerServiceProviderCreate, (state) => ({
    ...state,
    success: '',
    error: ''
  })),
  on(MailerServiceProviderCreateSuccess, (state) => ({
    ...state,
    success: 'Provider added successfully',
    error: ''
  })),
  on(MailerServiceProviderCreateError, (state, {error}) => ({
    ...state,
    success: '',
    error
  })),
  on(MailerServiceProviderUpdate, (state) => ({
    ...state,
    success: '',
    error: ''
  })),
  on(MailerServiceProviderUpdateSuccess, (state) => ({
    ...state,
    success: 'Provider updated successfully',
    error: ''
  })),
  on(MailerServiceProviderUpdateError, (state, {error}) => ({
    ...state,
    success: '',
    error
  })),
  on(MailerServiceProviderSetDefault, (state) => ({
    ...state,
    success: '',
    error: ''
  })),
  on(MailerServiceProviderSetDefaultSuccess, (state) => ({
    ...state,
    success: 'Default provider updated successfully',
    error: ''
  })),
  on(MailerServiceProviderSetDefaultError, (state, {error}) => ({
    ...state,
    success: '',
    error
  })),
  on(ResetMailerServiceProviderState, (state, {params}) => ({
    ...state,
    ...params
  })),
);

export function mailerServiceProviderReducer(state = initialMailerServiceProviderState, action: Action) {
  return generateReducer(state, action);
}
